import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.scss';
import 'bootstrap/dist/css/bootstrap.css';
// Import FontAwesome configuration
import './libs/fontawesome';
import ImportedApp from './App';
import * as serviceWorkerRegistration from './registerServiceWorker';
import Header from './components/common/Header.jsx';
import Footer from './components/common/Footer.jsx';
import ROAppointmentDetails from './components/readOnlyView/ROAppointmentDetails.jsx';

function App() {
    const [state, setState] = useState({
        roView: false,
        d: null,
        ct: null,
        i: null
    });
    
    useEffect(() => {
        let roView = false;
        if (window.location.href.indexOf('view=ro') !== -1) {
            roView = true;
            const url = new URL(window.location.href);
            const d = url.searchParams.get("d");
            const ct = url.searchParams.get("ct");
            const i = url.searchParams.get("i");

            setState({ roView, d, ct, i });
        }
    }, []);
    
    return (
        state.roView ?
            <div>
                <ROAppointmentDetails d={state.d} ct={state.ct} i={state.i} />
            </div>
            :
            <div>
                <Header />
                <ImportedApp />
                <Footer />
            </div>
    );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below
serviceWorkerRegistration.unregister();
